import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { HighchartsChartModule } from 'highcharts-angular';
import { UiChartsComponent } from './ui-charts/ui-charts.component';

@NgModule({
  imports: [CommonModule, IonicModule, HighchartsChartModule],
  declarations: [UiChartsComponent],
  exports: [UiChartsComponent],
})
export class ChartingModule {}
